import axios from 'axios';
import { getAppContext } from '../config/appContext';

function getPublicApiUrl() {
  const ctx = getAppContext();
  const origin = ctx.apiBaseUrl.replace(/\/api\/platform$/, '');
  return `${origin}/api/public`;
}

const publicMapService = {
  async fetchClientsMap() {
    const { data } = await axios.get(`${getPublicApiUrl()}/clients-map`, {
      timeout: 10000,
      headers: { Accept: 'application/json' },
    });
    return data;
  },
};

export default publicMapService;
